import React from "react";

import '../css/Services.css';
import { getOSSImage } from "./Utils";

const titleImage = getOSSImage('zi_title_tuandui.png');
const contentImage = getOSSImage('tuandui.png');

export default function Services() {
    return(
        <div id="services" className="services-container">
            <img className="services-tile" alt="services-title" src={titleImage}/>
            <img className="services-value" alt="services-value" src={contentImage}/>
        </div>
    )
}